<template>
  <nav class="service-sidebar flex flex-col items-center justify-between textured-background">
    <div class="flex flex-col items-center w-full">
      <div class="pt-5 pb-3 mt-3 cursor-pointer" @click.stop="onClickedHome">
        <img :src="logo" width="52" />
      </div>
      <vs-divider class="mt-0" color="grey" />
      <ul class="">
        <li :key="idx" v-for="(item, idx) in servicesWithPermission">
          <a
            style="cursor: pointer"
            class="p-3 flex flex-col relative"
            @click.stop="changeService(item, item.idx)"
            :class="{ active: item.name === currentService.name }"
          >
            <div>
              <img v-if="item.name == 'Venue'" :src="currentService.name == 'Venue' ? homeIconSelected : homeIcon" width="26" />
              <img
                v-else-if="item.name == 'Reports'"
                :src="currentService.name == 'Reports' ? reportsIconSelected : reportsIcon"
                width="30"
              />
              <img v-else-if="item.name == 'LIFE'" :src="currentService.name == 'LIFE' ? lifeIconSelected : lifeIcon" width="32" />
              <img v-else-if="item.name == 'CRM'" :src="currentService.name == 'CRM' ? crmIconSelected : crmIcon" width="30" />
              <img v-else-if="item.name == 'Guests'" :src="currentService.name == 'Guests' ? crmIconSelected : crmIcon" width="30" />
              <img v-else-if="item.name == 'Upkeep'" :src="currentService.name == 'Upkeep' ? pimIconSelected : pimIcon" width="30" />
              <img
                v-else-if="item.name == 'Overview'"
                :src="currentService.name == 'Overview' ? reportsIconSelected : reportsIcon"
                width="30"
              />
            </div>
            <!-- <feather-icon
              svgClasses="h-7 w-7"
              class="menu-icon"
              style="color: rgb(var(--vs-success))"
              :icon="item.icon"
            /> -->

            <span class="service-name pb-1 mt-0"> {{ item.name }}</span>
            <div class="service-wave"></div>
          </a>
        </li>
      </ul>
    </div>
    <div class="flex flex-col items-center mb-6">
      <profile-drop-down class="mb-4" />
      <img
        :src="isVerticalNavMenuActive ? sidebarFoldInIcon : sidebarFoldOutIcon"
        alt="user-img"
        width="24"
        class="cursor-pointer block"
        @click.stop="showSidebar"
      />
      <!-- <feather-icon
        svgClasses="h-8 w-8"
        class="menu-icon"
        :icon="isVerticalNavMenuActive ? 'CornerDownLeftIcon' : 'CornerDownRightIcon'"
        @click.stop="showSidebar"
      /> -->
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileDropDown from "../navbar/components/ProfileDropDown.vue";
import logo from "@/assets/images/rekom_logo_clean.svg";
import homeIcon from "@/assets/images/home-icon-white.png";
import reportsIcon from "@/assets/images/reports-icon-white.png";
import lifeIcon from "@/assets/images/users-icon-white.png";
import crmIcon from "@/assets/images/shout-icon-white.png";
import pimIcon from "@/assets/images/trolley-icon-white.png";
import homeIconSelected from "@/assets/images/home-icon-success.png";
import reportsIconSelected from "@/assets/images/reports-icon-success.png";
import lifeIconSelected from "@/assets/images/users-icon-success.png";
import crmIconSelected from "@/assets/images/shout-icon-success.png";
import pimIconSelected from "@/assets/images/trolley-icon-success.png";

import sidebarFoldInIcon from "@/assets/images/sidebar-fold-in-icon.png";
import sidebarFoldOutIcon from "@/assets/images/sidebar-fold-out-icon.png";
export default {
  components: { ProfileDropDown },
  data() {
    return {
      logo,
      homeIcon,
      reportsIcon,
      lifeIcon,
      crmIcon,
      homeIconSelected,
      reportsIconSelected,
      lifeIconSelected,
      crmIconSelected,
      pimIcon,
      pimIconSelected,
      sidebarFoldInIcon,
      sidebarFoldOutIcon
    };
  },
  computed: {
    ...mapGetters({
      servicesWithPermission: "services/servicesWithPermission",
      currentService: "services/currentService"
    }),
    isVerticalNavMenuActive() {
      return this.$store.state.themeProps.isVerticalNavMenuActive;
    }
  },
  methods: {
    onClickedHome() {
      this.$router.push("/");
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    changeService(service, idx) {
      this.switchService(service, idx);
    }
  }
};
</script>
<style lang="scss"  scoped>
@font-face {
  font-family: "HelNeue";
  src: url("./fonts/Helvetica-Neue-Condensed-Bold.woff") format("woff"),
    /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */ url("./fonts/Helvetica-Neue-Condensed-Bold.ttf") format("truetype"); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}

.textured-background {
  background-image: url("../../../assets/images/texture_dark.png") !important;
  background-repeat: repeat;
}

.service-sidebar {
  left: 0px;
  top: 0px;
  width: 76px;
  background-color: #051b19;
  height: 100vh;
  position: fixed;
  z-index: 4001;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

li {
  flex-grow: 1;
}

a {
  font-family: HelNeue;
  text-decoration: none;

  font-size: 15px;

  display: block;
  padding: 1em;
  text-align: center;
  margin-bottom: 0.2em;
  text-decoration: none;
  color: white;
  width: 100%;
}

.menu-icon {
  margin: 0 auto;
  cursor: pointer;
  color: rgba(var(--vs-beige), 1);
}
.menu-icon:hover {
  opacity: 0.75;
}

.service-wave {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 8px;
  margin: 0 auto;
  width: 42px;
  height: 8px;
}

.service-name {
  letter-spacing: 0.08em;
}

a:hover {
  .service-wave {
    background-image: url("../../../assets/images/hover_white.svg");
    background-position: 0 100%;
    background-size: auto 46px;
    background-repeat: repeat;
  }
  .service-name {
    text-decoration: none;
    border-bottom: none;
  }
  .menu-icon {
    // color: rgba(var(--vs-success), 1);
    opacity: 0.75;
  }
  // color: rgba(var(--vs-success), 1);
}
li a.active {
  .menu-icon {
    color: rgba(var(--vs-success), 1);
  }
  color: rgba(var(--vs-success), 1);
}

/* Google benytter     width: 187px; */
</style>
